/* eslint-disable */ 
import React from "react";
import styled from "styled-components";
import Chart from "./Chart";
// import { Icon } from "./Icon";
// import { Link } from "react-router-dom";

// /*Dashboard Page */
// const Headers = [
//   "Month",
//   "Daily",
//   "Daily Target",
//   "Monthly",
//   "Monthly Target",
//   "Productivity",
//   "Productivity Target",
//   "Agent Number",
//   "Agent Number Target",
//   "Truck Number",
//   "Truck Number Target",
//   "xDock Number",
//   "xDock Number Target",
//   "Ticket Percentage",
//   "Ticket Percentage Target",
//   "Delivery Performance",
//   "Delivery Performance Target"
// ];
// const Table = [
//   [
//     "Jan-17",
//     685,
//     685,
//     16445,
//     16445,
//     40,
//     undefined,
//     17,
//     undefined,
//     2,
//     undefined,
//     2,
//     undefined,
//     0.99,
//     1,
//     99.1,
//     97
//   ],
//   [
//     "Feb-17",
//     1016,
//     1016,
//     24392,
//     24392,
//     42,
//     50,
//     24,
//     35,
//     3,
//     2,
//     3,
//     3,
//     1.67,
//     1,
//     99.3,
//     97
//   ],
//   [
//     "Mar-17",
//     2080,
//     2080,
//     56245,
//     56245,
//     47,
//     50,
//     45,
//     50,
//     4,
//     3,
//     5,
//     5,
//     1.1,
//     1,
//     100,
//     97
//   ],
//   [
//     "Apr-17",
//     2481,
//     2481,
//     62326,
//     62326,
//     41,
//     50,
//     60,
//     70,
//     5,
//     3,
//     5,
//     5,
//     0.65,
//     1,
//     99.1,
//     97
//   ],
//   [
//     "May-17",
//     2831,
//     2831,
//     77589,
//     77589,
//     37,
//     50,
//     76,
//     90,
//     5,
//     6,
//     7,
//     5,
//     1.25,
//     1,
//     99,
//     97
//   ],
//   [
//     "Jun-17",
//     3189,
//     3189,
//     84123,
//     84123,
//     38,
//     60,
//     83,
//     100,
//     8,
//     6,
//     7,
//     8,
//     2.69,
//     1,
//     98.5,
//     97
//   ],
//   [
//     "Jul-17",
//     3367,
//     3367,
//     89013,
//     89013,
//     37,
//     60,
//     92,
//     100,
//     8,
//     6,
//     8,
//     8,
//     1.23,
//     1,
//     98.7,
//     97
//   ],
//   [
//     "Aug-17",
//     3461,
//     3461,
//     95666,
//     95666,
//     35,
//     60,
//     104,
//     120,
//     9,
//     6,
//     8,
//     8,
//     0.98,
//     1,
//     98.47,
//     97
//   ],
//   [
//     "Sep-17",
//     4279,
//     4279,
//     107169,
//     107169,
//     40,
//     70,
//     106,
//     120,
//     10,
//     6,
//     8,
//     8,
//     1.18,
//     1,
//     93.2,
//     97
//   ],
//   [
//     "Oct-17",
//     5081,
//     5081,
//     127550,
//     127550,
//     44,
//     70,
//     115,
//     140,
//     10,
//     6,
//     9,
//     8,
//     0.46,
//     1,
//     98.1,
//     97
//   ],
//   [
//     "Nov-17",
//     5773,
//     5773,
//     161518,
//     161518,
//     44,
//     70,
//     130,
//     150,
//     10,
//     6,
//     9,
//     8,
//     0.24,
//     1,
//     98.36,
//     97
//   ],
//   [
//     "Dec-17",
//     6020,
//     6020,
//     172765,
//     150000,
//     47,
//     70,
//     127,
//     160,
//     10,
//     6,
//     10,
//     8,
//     0.31,
//     1,
//     98.34,
//     97
//   ]
// ];

const header2 = ["Average Daily Shipment", "Average Courier Shipment"];
const table2 = [
  ["w/1", 586, 41],
  ["w/2", 434, 28],
  ["w/3", 739, 40],
  ["w/4", 872, 46],
  ["w/5", 811, 40],
  ["w/6", 1015, 48],
  ["w/7", 1019, 48],
  ["w/8", 1050, 44],
  ["w/9", 1492, 48],
  ["w/10", 1739, 48],
  ["w/11", 1966, 46],
  ["w/12", 2470, 47],
  ["w/13", 2388, 40],
  ["w/14", 2146, 36],
  ["w/15", 2482, 39],
  ["w/16", 2435, 39],
  ["w/17", 3031, 47],
  ["w/18", 2611, 38],
  ["w/19", 3240, 44],
  ["w/20", 2790, 35],
  ["w/21", 2549, 32],
  ["w/22", 3013, 34],
  ["w/23", 3583, 39],
  ["w/24", 3661, 39],
  ["w/25", 3331, 38],
  ["w/26", 2149, 30],
  ["w/27", 3016, 34],
  ["w/28", 2821, 31],
  ["w/29", 3854, 41],
  ["w/30", 3627, 39],
  ["w/31", 3568, 36],
  ["w/32", 3793, 39],
  ["w/33", 3190, 33],
  ["w/34", 4056, 39],
  ["w/35", 1981, 25]
];

const Container = styled.section`
  border-radius: 3px;
  border: 1px solid #d7d7d9;
  box-shadow: 0 10px 22px 0 rgba(0, 0, 0, 0.01);
  margin: 20px;
  background: white;
  color: #333333;
`;

const Header = styled.section`
  padding: 10px 20px;
  background: #e8e8e9;
  position: relative;
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.h1`
  font-size: 18px;
  padding: 10px 0;
`;

// export const MenuIcon = styled(Icon)`
//   font-size: 20px;
//   padding: 10px;
//   cursor: pointer;
// `;

export const Board = props => {
  return (
    <Container>
      <Header>
        <Title>{props.definition}</Title>
        <div />
      </Header>
      {props.children}
    </Container>
  );
};

// export const Grid = props => (
//   <Table>
//     {props.items.map((item, index) => <Row key={index}>{item[0]}</Row>)}
//   </Table>
// );

// const options = {
//   chart: {
//     type: "area"
//   },
//   title: {
//     text: "End To End Performance"
//   },
//   subtitle: {
//     text: "Source: Wikipedia.org"
//   },
//   xAxis: {
//     categories: ["Müşteri", "Depo XDock", "Ring Aracı", "XDock", "Taşımacı"],
//     tickmarkPlacement: "on",
//     title: {
//       enabled: false
//     }
//   },
//   yAxis: {
//     title: {
//       text: "Percentage"
//     }
//   },
//   tooltip: {
//     split: true,
//     valueSuffix: " millions"
//   },
//   plotOptions: {
//     area: {
//       stacking: "normal",
//       lineColor: "#666666",
//       lineWidth: 1,
//       marker: {
//         lineWidth: 1,
//         lineColor: "#666666"
//       }
//     }
//   },
//   series: [
//     (chart: {
//       type: "area"
//     }),
//     {
//       name: "Günlük",
//       data: [502, 635, 809, 947, 1402]
//     },
//     {
//       name: "Haftalık",
//       data: [106, 107, 111, 133, 221]
//     },
//     {
//       name: "Aylık",
//       data: [163, 203, 276, 408, 547]
//     },
//     {
//       name: "Yıllık",
//       data: [18, 31, 54, 156, 339]
//     },
//     {
//       name: "Toplam",
//       data: [2, 2, 2, 6, 13]
//     }
//   ]
// };

// const jsonData = {"title":{"text":"My Chart"},"subtitle":{"text":"My Untitled Chart"},"exporting":{},"yAxis":{"title":{}},"series":[{"name":"Tokyo","turboThreshold":0,"_colorIndex":0,"_symbolIndex":0},{"name":"New York","turboThreshold":0,"_colorIndex":1,"_symbolIndex":1},{"name":"Berlin","turboThreshold":0,"_colorIndex":2,"_symbolIndex":2},{"name":"London","turboThreshold":0,"_colorIndex":3,"_symbolIndex":3}],"plotOptions":{"series":{"animation":false}},"data":{"csv":"\"Categories\";\"Tokyo\";\"New York\";\"Berlin\";\"London\"\n\"Jan\";7;-0.2;-0.9;3.9\n\"Feb\";6.9;0.8;0.6;4.2\n\"Mar\";9.5;5.7;3.5;5.7\n\"Apr\";14.5;11.3;8.4;8.5\n\"May\";18.2;17;13.5;11.9\n\"Jun\";21.5;22;17;15.2\n\"Jul\";25.2;24.8;18.6;17\n\"Aug\";26.5;24.1;17.9;16.6\n\"Sep\";23.3;20.1;14.3;14.2\n\"Oct\";18.3;14.1;9;10.3\n\"Nov\";13.9;8.6;3.9;6.6\n\"Dec\";9.6;2.5;1;4.8","googleSpreadsheetKey":false,"googleSpreadsheetWorksheet":false}}
// const jsonData = {
//   chart: {
//     type: "column"
//   },
//   series: [
//     {
//       name: "Günlük",
//       data: [502, 635, 809, 947, 1402]
//     },
//     {
//       name: "Haftalık",
//       data: [106, 107, 111, 133, 221]
//     },
//     {
//       name: "Aylık",
//       data: [163, 203, 276, 408, 547]
//     },
//     {
//       name: "Yıllık",
//       data: [18, 31, 54, 156, 339]
//     },
//     {
//       name: "Toplam",
//       data: [2, 2, 2, 6, 13]
//     }
//   ],
//   title: {
//     text: "Fruit Consumption"
//   },
//   yAxis: {
//     title: {
//       text: "Units"
//     }
//   },
//   credits: {
//     enabled: true,
//     text: "Hepsijet",
//     href: "hepsijet.com"
//   }
// };

const jsonData2 = {
  chart: {
    type: "column"
  },
  title: {
    text: "Hepsijet Growth, Actual YTD and Forecast"
  },
  subtitle: {
    text: "Actual Daily Shipment vs. Target"
  },
  xAxis: {
    categories: [
      "Jan-17",
      "Feb-17",
      "Mar-17",
      "Apr-17",
      "May-17",
      "Jun-17",
      "Jul-17",
      "Aug-17",
      "Sep-17",
      "Oct-17",
      "Nov-17",
      "Dec-17"
    ],
    crosshair: true
  },
  yAxis: {
    min: 0,
    title: {
      text: "Delivery (1000)"
    }
  },
  tooltip: {
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
    footerFormat: "</table>",
    shared: true,
    useHTML: true
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: [
    {
      name: "Actual same day+next day",
      data: [16445, 24392, 56245, 62326, 77589, 84123, 89013, 95666]
    },
    {
      name: "Target",
      data: [
        16445,
        24392,
        56245,
        62326,
        77589,
        84123,
        89013,
        95666,
        128000,
        155000,
        219000,
        267000,
        1218554
      ]
    }
  ],
  credits: {
    enabled: true,
    text: "Hepsijet",
    href: "hepsijet.com"
  }
};

const jsonData3 = {
  chart: {
    type: "column"
  },
  title: {
    text: "Hepsijet Growth, Actual YTD and Forecast"
  },
  subtitle: {
    text: "Actual Daily Shipment vs. Target"
  },
  xAxis: {
    categories: [
      "w/1",
      "w/2",
      "w/3",
      "w/4",
      "w/5",
      "w/6",
      "w/7",
      "w/8",
      "w/9",
      "w/10",
      "w/11",
      "w/12",
      "w/13",
      "w/14",
      "w/15",
      "w/16",
      "w/17",
      "w/18",
      "w/19",
      "w/20",
      "w/21",
      "w/22",
      "w/23",
      "w/24",
      "w/25",
      "w/26",
      "w/27",
      "w/28",
      "w/29",
      "w/30",
      "w/31",
      "w/32",
      "w/33",
      "w/34",
      "w/35"
    ],
    crosshair: true
  },
  yAxis: [
    {
      min: 0,
      title: {
        text: "Delivery"
        // style: {
        //   color: Highcharts.getOptions().colors[0]
        // }
      }
    },
    {
      min: 0,
      title: {
        text: "Average shipment by couriers"
        // style: {
        //   color: Highcharts.getOptions().colors[1]
        // }
      },
      opposite: true
    }
  ],
  tooltip: {
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
    footerFormat: "</table>",
    shared: true,
    useHTML: true
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: [
    {
      name: "Average Daily Shipment",
      data: [
        586,
        434,
        739,
        872,
        811,
        1015,
        1019,
        1050,
        1492,
        1739,
        1966,
        2470,
        2388,
        2146,
        2482,
        2435,
        3031,
        2611,
        3240,
        2790,
        2549,
        3013,
        3583,
        3661,
        3331,
        2149,
        3016,
        2821,
        3854,
        3627,
        3568,
        3793,
        3190,
        4056,
        1981
      ],
      credits: {
        enabled: true,
        text: "Hepsijet",
        href: "hepsijet.com"
      }
    },
    {
      name: "Average Courier Shipment",
      yAxis: 1,
      type: "spline",
      data: [
        41,
        28,
        40,
        46,
        40,
        48,
        48,
        44,
        48,
        48,
        46,
        47,
        40,
        36,
        39,
        39,
        47,
        38,
        44,
        35,
        32,
        34,
        39,
        39,
        38,
        30,
        34,
        31,
        41,
        39,
        36,
        39,
        33,
        39,
        25
      ]
    }
  ],
  credits: {
    enabled: true,
    text: "Hepsijet",
    href: "hepsijet.com"
  }
};

export const BoardChart = props => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <Chart options={jsonData2} />
    <Chart options={jsonData3} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/data2.js